import styled, { keyframes } from "styled-components";

const cardAnimation = keyframes`
    0% {
        opacity: 0;
        transform: translateY(10%);
    }
    100% {
        opacity: 1;
        transform: translateY(0%);
    }
`;

export const WithAnimationContainer = styled.div`
    & > * {
        opacity: 0;
        animation: ${cardAnimation} 0.5s ease-in-out forwards;
    }
`;
